/**
 * Single source of truth for validation thresholds.
 *
 * #132 fix (2026-05-18): extracted from authService / Register / validation
 * etc. so the UI message, the client-side check, and the test assertion all
 * reference the same number. Previously the test asserted `at least 6`
 * while the UI said `at least 8` — silent drift made the test pass against
 * the wrong threshold.
 *
 * NIST SP 800-63B (2026): 8 char minimum, 15+ recommended, no required
 * character classes, no mandatory rotation.
 */

export const MIN_PASSWORD_LENGTH = 8;
export const MIN_DISPLAY_NAME_LENGTH = 2;
export const MIN_PROJECT_TITLE_LENGTH = 3;
export const MIN_PROJECT_DESCRIPTION_LENGTH = 10;
export const MAX_TITLE_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 500;

export const PASSWORD_REQUIREMENT_MESSAGE = `Password must be at least ${MIN_PASSWORD_LENGTH} characters`;
export const PASSWORD_STRONG_MESSAGE = `Password must be at least ${MIN_PASSWORD_LENGTH} characters with uppercase, lowercase, and number`;
